import React from "react";
import { Link } from "react-router-dom";

function PopUp() {
  return (
    <div className="bg-[#DCAE96] flex flex-col gap-4 text-[#2A5801] px-[10px] pt-[20px] pb-[20px] rounded-[5px]">
      <Link to="/chat">
        <div className="bg-white border-white rounded-[8px] flex gap-2 py-[3px] px-[9px]">
          <img
            className="w-7 h-7"
            src="https://res.cloudinary.com/dxswouxj5/image/upload/v1701722601/Chat_na69hl.png"
            alt="chat"
          />
          <h3 className="">Chat</h3>
        </div>
      </Link>
      <Link to="/voicecall">
        <div className="bg-white border-white  rounded-[8px] flex py-[3px] px-[9px]">
          <img
            className="w-7 h-7"
            src="https://res.cloudinary.com/dxswouxj5/image/upload/v1701722533/Call_jkskdi.png"
            alt="voice call"
          />
          <h3 className="ml-[15px]">Voice Call</h3>
        </div>
      </Link>
      <Link to="/videocall">
        <div className="bg-white border-white  rounded-[8px] flex gap-2 py-[3px] px-[9px]">
          <img
            className="w-7 h-7"
            src="https://res.cloudinary.com/dxswouxj5/image/upload/v1701722600/Video_Call_kazprq.png"
            alt="video call"
          />
          <h3 className="">Video Call</h3>
        </div>
      </Link>
    </div>
  );
}

export default PopUp;
